import { combineReducers } from "redux"
import products from './reducers.js'

export default combineReducers({products})